import React, { useState } from 'react'
import { FaFacebookF } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Base64 } from 'js-base64';
import { useHistory, useParams } from 'react-router-dom';
import logo from '../../../../assets/images/logo/Haylo-for-white-background.png'
import { baseURLPublic } from '../../../../config/BaseUrl'

function MicrositeOnePassword() {

  const { id } = useParams()
  const history = useHistory();
  const eventId = Base64.atob(id);
  const [password, setPassword] = useState("")
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const checkPassword = (e) => {
    e.preventDefault()
    setLoading(true)
    const data = {
      password,
      eventId
    }

    baseURLPublic.post(`/check-gallery-password`, data)
      .then(res=>{
        if (res.data.message == 'success') {
          setLoading(false)
          setError(null)
          localStorage.setItem('galleryPasswordCheck', true)
          history.push(`/social/gallery/${id}`)
        }
        else{
          setLoading(false)
          setError(res.data.message)
        }
      })

  }

  return (


    <div className="Customer-microsite-one d-flex flex-column">

      <div className="header default-header">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="header-image text-center py-4">
                <img src={logo} className="img-fluid" alt="logo" style={{ width: "250px" }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-body mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-6">
              <div className="gallery-item-view mt-5">
                <div className="password-protection-body">
                  <form onSubmit={checkPassword}>
                    <div className="mb-3">
                      <label for="exampleInputPassword1" className="form-label">Password</label>
                      <input type="password" name="password" value={password} onChange={e=> setPassword(e.target.value)} className="form-control" id="exampleInputPassword1" required />
                      <span className="text-danger">{error}</span>
                    </div>
                    <div className="text-right">
                      <button type="submit" disabled={loading} className="btn btn-primary">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-microsite-one">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p className="text-center footer-name">Brought you by <Link to="#" style={{ color: "#fff" }}>The Haylo</Link></p>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default MicrositeOnePassword
